<template>
<div>
    <div class="container-fluid container-froDesk">
        <div class="wrapper">
            <div class="content-page content-froDesk">
                <div class="content">
                    <div class="row">
                        <!-- 项目管理 -->
                        <div class="col-lg-12">
                            <div class="card">
                                <div class="card-body">
                                    <img class="build-img" src="@/assets/images/yf_images/build-img.png" alt="此栏目正在建设中">
                                </div> <!-- end card-body-->
                            </div> <!-- end card-->
                        </div>
                        <!-- end 项目管理-->
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>
  
</template>
<script>
export default {
    name:"projectManagement",
    data() {
        return {
        };
    },
    mounted() {
    },
    methods: {},
};
</script>
<style lang="scss" scoped>
</style>